
import React from 'react';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { DatePicker } from '@/components/ui/date-picker';

export type PaymentType = 'all' | 'salary' | 'fee';
export type DateRange = '7' | '30' | '90' | 'current-month' | 'last-month' | 'current-year' | 'last-year' | 'all' | 'custom';

interface RevenueFiltersProps {
  paymentType: PaymentType;
  dateRange: DateRange;
  searchQuery: string;
  customDate?: Date;
  onPaymentTypeChange: (value: PaymentType) => void;
  onDateRangeChange: (value: DateRange) => void;
  onSearchQueryChange: (value: string) => void;
  onCustomDateChange?: (date?: Date) => void;
}

export const RevenueFilters = ({
  paymentType,
  dateRange,
  searchQuery,
  customDate,
  onPaymentTypeChange,
  onDateRangeChange,
  onSearchQueryChange,
  onCustomDateChange,
}: RevenueFiltersProps) => {
  return (
    <div className="flex flex-wrap gap-4 mb-6">
      <Select value={paymentType} onValueChange={onPaymentTypeChange}>
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="Payment Type" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Payments</SelectItem>
          <SelectItem value="salary">Teacher Salaries</SelectItem>
          <SelectItem value="fee">Student Fees</SelectItem>
        </SelectContent>
      </Select>

      <Select value={dateRange} onValueChange={onDateRangeChange}>
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="Date Range" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="current-month">Current Month</SelectItem>
          <SelectItem value="last-month">Last Month</SelectItem>
          <SelectItem value="current-year">Current Year</SelectItem>
          <SelectItem value="last-year">Last Year</SelectItem>
          <SelectItem value="7">Last 7 Days</SelectItem>
          <SelectItem value="30">Last 30 Days</SelectItem>
          <SelectItem value="90">Last 90 Days</SelectItem>
          <SelectItem value="custom">Custom Date</SelectItem>
          <SelectItem value="all">All Time</SelectItem>
        </SelectContent>
      </Select>

      {dateRange === 'custom' && (
        <DatePicker
          date={customDate}
          onChange={onCustomDateChange}
          className="w-[200px]"
        />
      )}

      <div className="flex-1">
        <Input
          placeholder="Search by name, description, or reference..."
          value={searchQuery}
          onChange={(e) => onSearchQueryChange(e.target.value)}
          className="w-full"
        />
      </div>
    </div>
  );
};
